import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild, forwardRef, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ClientMessages } from '@hub/generated/_messages';
import { FormEventService } from '@hub/services/form-event.service';
import { NotificationService } from '@hub/services/index';
import { Subject ,  Subscription } from 'rxjs';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';

const noop = () => { };

export const CUSTOM_INPUTAUTO_CONTROL_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => FormAutocompleteComponent),
	multi: true
};

@Component({
	selector: 'fm-autocomplete',
	templateUrl: 'form-autocomplete.component.html',
	providers: [CUSTOM_INPUTAUTO_CONTROL_VALUE_ACCESSOR]
})
export class FormAutocompleteComponent extends BaseErrorForm
	implements ControlValueAccessor, OnInit, OnDestroy {
	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		public formEventService: FormEventService,
		private notificationService: NotificationService
	) {
		super();
	}

	@Output() completeMethod: EventEmitter<any> = new EventEmitter();
	@Output() onDropdownClick: EventEmitter<any> = new EventEmitter();
	@Output() onSelectItem: EventEmitter<any> = new EventEmitter();

	results: Subject<Array<object>> = new Subject<Array<object>>();
	getClicks: Subscription;
	placeholder: string;
	@Input() resetBtn: boolean = true;

	@Input() disabled: boolean = false;
	@Input() field: string = "Name";
	@Input() size: number = 50;

	tabindex: string;
	@Input('tabindex')
	set tabin(val: string) {
		this.tabindex = String(val);
	}

	@Output() onSelectValue: EventEmitter<any> = new EventEmitter();
	@Output() onClearMethod: EventEmitter<any> = new EventEmitter();


	private numOfTabs: number = 0;
	private clickEvent: Subject<boolean> = new Subject<boolean>();
	private innerValue: any = '';

	// Placeholders for the callbacks which are later provided
	// by the Control Value Accessor
	private onTouchedCallback: () => void = noop;
	private onChangeCallback: (_: any) => void = noop;

	@ViewChild('content', { read: ElementRef })
	private content: ElementRef;

	@Input('suggestions')
	set suggestions(val: Array<object>) {
		this.results.next(val);
	}

	ngOnInit() {
		this.formEventService.setIndex(parseInt(this.tabindex));
		this.placeholder = "Type..."
		this.getClicks = this.clickEvent.subscribe(
			x => {
				setTimeout(() => {
					const element: HTMLElement = this.el.nativeElement.querySelector(
						'input'
					);
					if (element != null) {
						element.focus();
					}
				}, 0);
			},
			err => {
				this.notificationService.error(ClientMessages.BaseErrorMessage);
			}
		);
	}

	ngOnDestroy() {
		this.results.complete();
		if (this.getClicks) {
			this.getClicks.unsubscribe();
		}
	}

	@HostListener('keydown.enter', ['$event'])
	handleEnter(event: any) {
		if (this.numOfTabs === 0) {
			const elem: HTMLElement = this.content.nativeElement;
			elem.querySelector('a').click();
		}
	}

	handleDropdown(event: any) {
		event.originalEvent.stopPropagation();
		this.onDropdownClick.emit(event);
	}

	search(event: object) {
		this.completeMethod.emit(event);
	}

	@Input()
	get value(): any {
		return this.innerValue;
	}

	// set accessor including call the onchange callback
	set value(v: any) {
		if (v !== this.innerValue) {
			this.innerValue = v;
			this.onChangeCallback(v);
		}
	}

	onClick(event: MouseEvent) {
		event.stopPropagation();
		this.formEventService.changeFocus(this.tabindex);
		this.clickEvent.next(true);
		// this.formEventService.setFocusIn(true);

	}

	resetValue(event: any): void {
		this.writeValue(event);
		this.onChangeCallback(event);
	}

	// Set touched on blur
	onBlur(event) {
		this.onTouchedCallback();
	}

	onSelect(event: Event) {
		this.writeValue(event);
		this.onChangeCallback(event);
		this.onSelectItem.emit(event);
	}

	onFocus(event: Event) {
		this.onTouchedCallback();
	}

	// From ControlValueAccessor interface
	writeValue(value: any) {
		if (value !== this.innerValue) {
			this.innerValue = value;
		}
	}

	// From ControlValueAccessor interface
	registerOnChange(fn: any) {
		this.onChangeCallback = fn;
	}

	// From ControlValueAccessor interface
	registerOnTouched(fn: any) {
		this.onTouchedCallback = fn;
	}

	onClear(event: Event) {
		this.onClearMethod.emit(event);
	}
}
